import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';
import {generateScoreboard} from '#core/application/modules/tiles/scoreboard/index.js';

const AVANTGARDE_ODDS_BUTTON_HOVER_SCALE = {
    transform: 'scale(1.03)',
};

export function generateAvantgardeOddsButton(TILE) {
    return merge(generateOddsButton(TILE), {
        view: {
            containerInactivehover: AVANTGARDE_ODDS_BUTTON_HOVER_SCALE,
            containerActivehover: AVANTGARDE_ODDS_BUTTON_HOVER_SCALE,
        },
    });
}

const SCOREBOARD_FLAT_SHADOW = {
    boxShadow: 'none',
    _desktop_boxShadow: 'none',
    _mobile_boxShadow: 'none',
};

export function generateAvantgardeEventCardInplayScoreAccent(CARD_DETAILS) {
    return merge(generateScoreboard(CARD_DETAILS.SCOREBOARD), {
        showEventIndicators: false,
        showSportBackgroundImage: false,
        container: {
            style: {
                backgroundImage: 'none',
                ...resolveBackground('none'),
                ...SCOREBOARD_FLAT_SHADOW,
            },
        },
        content: {
            style: {
                ...resolveBackground('none'),
                ...SCOREBOARD_FLAT_SHADOW,
                borderRadius: '0',
            },
        },
        scoreboards: {
            preplayScoreboard: {
                container: {
                    style: SCOREBOARD_FLAT_SHADOW,
                },
                participantsBoard: {
                    container: {
                        style: SCOREBOARD_FLAT_SHADOW,
                    },
                },
            },
            genericInplayScoreboard: {
                container: {
                    style: SCOREBOARD_FLAT_SHADOW,
                },
            },
            outrightScoreboard: {
                container: {
                    style: SCOREBOARD_FLAT_SHADOW,
                },
            },
        },
    });
}
